<div class="p-10">
  <h2 class="text-3xl text-primary pb-12">Personenverwaltung</h2>
  <div class="container mx-auto p-4">
    <app-persons-list></app-persons-list>
  </div>
</div>
